/* <a href='https://www.freepik.com/photos/background'>Background photo created by tirachard - www.freepik.com</a> */
import bg from '../assets/bg.jpg';
import master from '../assets/Adrian.webp';
import G from '../assets/G.webp';
import gallery01 from '../assets/gallery01.webp';
import gallery02 from '../assets/gallery02.webp';
import gallery03 from '../assets/gallery03.webp';
import gallery04 from '../assets/gallery04.webp';
import gallery05 from '../assets/gallery05.webp';
import gallery06 from '../assets/gallery06.webp';
import scissors from '../assets/scissors.png';
import greybarber from '../assets/greybarber.webp';
import JackDaniels from '../assets/jackDaniels.webp';
import spoon from '../assets/spoon.svg';
import greyIntro from '../assets/greyIntro.webp';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import greybarberLogo from '../assets/greybarberLogo.webp';
import stopek from '../assets/stopek.png';

export default {
  bg,
  master,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  scissors,
  greybarber,
  JackDaniels,
  spoon,
  greyIntro,
  sign,
  quote,
  greybarberLogo,
  stopek,
};
